<template>
  <div>
    <hg-account-button />
    <hg-menu-list />
    <hg-report-menu />
  </div>
</template>

<script>
import MenuList from './MenuList.vue';
import AccountButton from './AccountButton.vue';
import ReportMenu from './ReportMenu.vue';

export default {
  components: {
    'hg-menu-list': MenuList,
    'hg-account-button': AccountButton,
    'hg-report-menu': ReportMenu,
  },
};
</script>
